
export interface OAuthProvider {
  id: string;
  name: string;
  displayName: string;
  colors: {
    bg: string;
    hover: string;
    text?: string;
  };
  icon: React.ReactNode | string;
  enabled: boolean;
}

export const OAUTH_PROVIDERS: Record<string, OAuthProvider> = {
  google: {
    id: 'google',
    name: 'Google',
    displayName: 'Google',
    colors: {
      bg: '#4285f4',
      hover: '#3367d6',
      text: '#ffffff'
    },
    icon: 'google', // Will be handled by GoogleOutlined from antd
    enabled: true // ✅ Ready to use
  },
  discord: {
    id: 'discord',
    name: 'Discord',
    displayName: 'Discord',
    colors: {
      bg: '#5865f2',
      hover: '#4752c4',
      text: '#ffffff'
    },
    icon: '🎮',
    enabled: false // 🚧 Enable when backend is ready
  },
  apple: {
    id: 'apple',
    name: 'Apple',
    displayName: 'Apple ID',
    colors: {
      bg: '#000000',
      hover: '#333333',
      text: '#ffffff'
    },
    icon: '/Apple_logo_grey.svg',
    enabled: true // ✅ Ready to use
  },
  facebook: {
    id: 'facebook',
    name: 'Facebook',
    displayName: 'Facebook',
    colors: {
      bg: '#1877f2',
      hover: '#166fe5',
      text: '#ffffff'
    },
    icon: '📘',
    enabled: false // 🚧 Enable when backend is ready
  },
  steam: {
    id: 'steam',
    name: 'Steam',
    displayName: 'Steam',
    colors: {
      bg: '#171a21',
      hover: '#2a475e',
      text: '#ffffff'
    },
    icon: '🎯',
    enabled: false // 🚧 Enable when backend is ready
  }
};

export const getEnabledProviders = (): OAuthProvider[] => {
  return Object.values(OAUTH_PROVIDERS).filter(provider => provider.enabled);
};

export const getProviderById = (id: string): OAuthProvider | undefined => {
  return OAUTH_PROVIDERS[id];
};

export const buildOAuthUrl = (provider: string, room: string, singlePlayer: boolean = false, isMobile: boolean = false): string => {
  const isDevelopment = process.env.NODE_ENV === 'development';
  const baseUrl = isDevelopment ? 'http://localhost:8080' : 'https://gamegarden.co';
  
  // Encode room and singlePlayer data into the state parameter
  const stateData = {
    room: room,
    singlePlayer: singlePlayer,
    timestamp: Date.now() // Add timestamp for security
  };
  const state = encodeURIComponent(JSON.stringify(stateData));
  
  // Add mobile callback parameter if on mobile
  const mobileParam = isMobile ? '&mobile_callback=true' : '';
  
  // Use standard OAuth2 endpoint path
  return `${baseUrl}/oauth2/authorization/${provider}?state=${state}${mobileParam}`;
};